import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  BtoDownloadResponse,
  BtoQuoteResponse,
  BtoRequest,
  BtoUploadResponse,
} from '../models/bto.model';
import { environment } from '../../environments/environment';
import {AuthService} from "./auth.service";

@Injectable({
  providedIn: 'root',
})
export class BtoQuoteService {
    constructor(private readonly http: HttpClient,
                private authService: AuthService) {}
    private getHeaders(): HttpHeaders {
        const token = this.authService.getAccessToken() || '';
        const host = window.location.hostname.toLowerCase();
        const domainExt = host.match(/\.(com|net)/)?.[0] || '';
        const domainStr = domainExt === '.com' ? 'com' : 'net';

        let headers = new HttpHeaders()
            .set('Authorization', `${token}`)
            .set('domain', domainStr);

        return headers;
    }

  getBtoItems(request: BtoRequest): Observable<BtoQuoteResponse> {
    const url = '/quotes';
    return this.http.post<BtoQuoteResponse>(url, request, { headers: this.getHeaders() });
  }

  uploadBtoDocument(request: BtoRequest): Observable<BtoUploadResponse> {
    const url = '/upload/bto-doc';
    return this.http.post<BtoUploadResponse>(url, request, { headers: this.getHeaders() });
  }

  viewBtoDocument(request: BtoRequest): Observable<BtoDownloadResponse> {
    const url = '/download/bto-doc';
    return this.http.post<BtoDownloadResponse>(url, request, { headers: this.getHeaders() });
  }
}
